import ElettrostimolatoreEdit from "./components/ElettrostimolatoreEdit.vue";
import ElettrostimolatoreView from "./components/ElettrostimolatoreView.vue";
import ElettrostimolatoreList from "./components/ElettrostimolatoreList.vue";

export default {
    ElettrostimolatoreEdit,
    ElettrostimolatoreView,
    ElettrostimolatoreList,
};
